import { useState, useEffect } from "react";
import StdLiveCards from "./StdLiveCards";
import { VirtuosoGrid } from "react-virtuoso";
import styled from "styled-components";

interface ILiveStudents {
	isLoading: boolean;
	students:
		| Array<{
				user: {
					firstName?: string;
					email: string;
				};
				_id: string;
		  }>
		| undefined;
	status: "live" | "submitted" | "unsubmitted";
	searchValue: string;
}

const ListContainer = styled.div`
	display: grid;
	gap: 1rem;
	grid-template-columns: repeat(1, minmax(0, 1fr));
	@media (min-width: 640px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	@media (min-width: 1024px) {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	@media (min-width: 1536px) {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
`;
export default function LiveStudents({
	students,
	isLoading,
	status,
	searchValue,
}: ILiveStudents) {
	const [filteredData, setFilteredData] = useState<
		Array<{
			user: {
				firstName?: string;
				email: string;
			};
			_id: string;
		}>
	>([]);

	useEffect(() => {
		if (!students) return;

		let searchTimeout = setTimeout(() => {
			let filtered_data = students.filter(
				(val) =>
					(val.user.firstName &&
						val.user.firstName
							.toLowerCase()
							.includes(searchValue.toLowerCase())) ||
					val.user.email
						.toLowerCase()
						.includes(searchValue.toLowerCase())
			);
			setFilteredData((prev) => [...filtered_data]);
		}, 500);

		return () => {
			clearTimeout(searchTimeout);
		};
	}, [students, searchValue]);

	return (
		<div className="stdLiveCards">
			{isLoading ? "Loading Please Wait..." : ""}
			<VirtuosoGrid
				components={{
					List: ListContainer,
				}}
				data={filteredData}
				useWindowScroll
				itemContent={(index, val) => (
					<StdLiveCards
						SName={val.user.firstName}
						SEmail={val.user.email}
						status={status}
						isClickable={true}
					/>
				)}
			/>
		</div>
	);
}

LiveStudents.defaultProps = {
	status: "live",
	searchValue: "",
};
